/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Org_Mismatches_OnlyInputs */

const cs_portals_org_mismatches_only = /** @type {(inputs: Portals_Org_Mismatches_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen neshody`)
};

const en_portals_org_mismatches_only = /** @type {(inputs: Portals_Org_Mismatches_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show mismatches only`)
};

/**
* | output |
* | --- |
* | "Show mismatches only" |
*
* @param {Portals_Org_Mismatches_OnlyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_org_mismatches_only = /** @type {((inputs?: Portals_Org_Mismatches_OnlyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Org_Mismatches_OnlyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_org_mismatches_only(inputs)
	return cs_portals_org_mismatches_only(inputs)
});